import { useContext, useEffect, useRef, useState } from 'react'
import { GlobalContext } from 'App'
import Lottie from 'react-lottie';
import * as animationData from './main.json'

const First = ({ activeIndex }: any) => {
  const { isTablet } = useContext(GlobalContext)

  const videoRef = useRef<any>()
  useEffect(() => {
    if (activeIndex === 0) {
      setTimeout(() => {
        videoRef.current?.play()
      })
    } else {
      videoRef.current?.pause()
    }
  }, [activeIndex])

  const setPlayBackRate = () => {
    videoRef.current.playbackRate = 1
  }

  const [endAni1, setEndAni1] = useState<boolean>(false);

  return (
    <div
      className={`flex bg-black w-full h-screen overflow-hidden justify-center items-center`}
      style={{ transition: 'all 2s ease-in' }}>
      {
        !endAni1 ?
          <Lottie
            options={{
              loop: false,
              autoplay: true,
              animationData: animationData,
              rendererSettings: {
                preserveAspectRatio: isTablet ? '' : 'xMidYMid slice'
              }
            }}
            isClickToPauseDisabled
            style={{ cursor: 'default', objectFit: 'contain' }}
            height={'100%'}
            width={'100%'}
            eventListeners={[
              {
                eventName: 'complete',
                callback: () => setEndAni1(true),
              },
            ]}
          /> :
          <video
            className={`w-full h-full ${isTablet ? 'object-contain' : 'object-cover'}`}
            muted
            autoPlay
            loop
            playsInline
            controls={isTablet}
            ref={videoRef}
            onCanPlay={() => setPlayBackRate()}>
            <source src="/video/main.mp4" type="video/mp4" />
          </video>
      }
    </div>
  )
}

export default First
